const textforreplace = [
  'First Name',
  'Last Name',
  'Email',
  'Company',
  'Select language',
  'Select country',
  'Password',
  'Confirm Password',
  'I accept the',
  'Terms of Service and Privacy policy',
  'Suscription to newsletter',
  'I am a Distributor',
  'Minimum 14 characters',
  'Logout',
  'Cancel',
  'Do you really want to logout?',
  'Sign In'
]

const replacetexts = content => {

  textforreplace.forEach(key => {

    content = content.replace(key, __(key))
  })

  return content
}

(function($) { 

  let $login = $('.xoo-el-section[data-section="login"]')
  if($login.length) {

    const validatecompletefields = {
      'input[name="xoo-el-username"]': {
        type: 'input',
        invalid: __('Please fill this field')
      },
      'input[name="xoo-el-password"]': {
        type: 'input',
        invalid: __('Please fill this field')
      }
    }

    Object.keys(validatecompletefields)
    .forEach(key => {

      const $field = $login.find(key).eq(0)
      $field.attr('oninvalid', 'setCustomValidity(\'' + validatecompletefields[key].invalid + '\')')
      if(validatecompletefields[key].type == 'input'){
        $field.attr("onblur", "setCustomValidity('')")
        $field.attr('oninput', "setCustomValidity('')")
      }
    })
    
    const $menuloginlink = $('#menu-login .xoo-el-login-tgr a, #menu-login-1 .xoo-el-login-tgr a')

    $menuloginlink
    .on(
      'click',
      function() {

        const now = new Date().getTime()

        const waitvalues = setInterval(() => {
          
          const $field = $login.find('input[name="xoo-el-username"]').eq(0)
          const fieldval = $field.val()

          if(fieldval != '' && !fieldval.includes('@')) {

            $field.val('')

            clearInterval(waitvalues)
          }

          const tick = new Date().getTime()

          if((tick - now) > (3 * 1000)) {

            clearInterval(waitvalues)
          }

        }, 100)
      }
    )
  }   

  let $lostpw = $('.xoo-el-section[data-section="lostpw"]')
  if($lostpw.length) {

    const validatecompletefields = {
      'input[name="user_login"]': {
        type: 'input',
        invalid: __('Please fill this field')
      }
    }

    Object.keys(validatecompletefields)
    .forEach(key => {

      const $field = $lostpw.find(key).eq(0)
      $field.attr('oninvalid', 'setCustomValidity(\'' + validatecompletefields[key].invalid + '\')')
      if(validatecompletefields[key].type == 'input'){
        $field.attr("onblur", "setCustomValidity('')")
        $field.attr('oninput', "setCustomValidity('')")
      }
    })
  }

  let $register = $('.xoo-el-section[data-section="register"]')
  if($register.length) {

    $register = $register.eq(0)

    const $form = $register.find('form.xoo-el-form-register')

    $form.html(replacetexts($form.html()))

    const validatecompletefields = {
      'input[name="xoo_el_reg_fname"]': {
        type: 'input',
        invalid: __('Please fill this field')
      },
      'input[name="xoo_el_reg_lname"]': {
        type: 'input',
        invalid: __('Please fill this field')
      },
      'input[name="xoo_el_reg_email"]':  {
        type: 'input',
        invalid: __('Invalid email')
      },
      'input[name="user_login"]':  {
        type: 'input',
        invalid: __('Please fill this field')
      },
      'input[name="academy_register_company"]':  {
        type: 'input',
        invalid: __('Please fill this field')
      },
      'select[name="academy_register_industry"]':  {
        type: 'select',
        invalid: __('Please select an option')
      },
      'select[name="academy_register_country"]':  {
        type: 'select',
        invalid: __('Please select an option')
      },
      'select[name="academy_register_language"]':  {
        type: 'select',
        invalid: __('Please select an option')
      },
      'input[name="xoo_el_reg_pass"]':  {
        type: 'input',
        invalid: __('Please fill this field')
      },
      'input[name="xoo_el_reg_pass_again"]':  {
        type: 'input',
        invalid: __('Please fill this field')
      }
    }

    Object.keys(validatecompletefields)
    .forEach(key => {

      const $field = $register.find(key).eq(0)
      $field.attr('oninvalid', 'setCustomValidity(\'' + validatecompletefields[key].invalid + '\')')
      if(validatecompletefields[key].type == 'input'){
        $field.attr("onblur", "setCustomValidity('')")
        $field.attr('oninput', "setCustomValidity('')")
      }
      if(validatecompletefields[key].type == 'select'){
        // $field.attr("onblur", "setCustomValidity('')")
        $field.attr('onchange', "setCustomValidity('')")
      }
    })

    const $selectregisterindustry = $register.find('.xoo-aff-select_list[name="academy_register_industry"]')

    fetch(
      '/wp-json/academy/user/categories',
      {
        method: 'GET',
        headers: {
          'X-WP-Nonce': academy_web_site.nonce
        }
      }
    )
    .then(result => {

      const optionselect = `<option value="">${__('Select industry')}</option>`

      result.json()
      .then(list => {

        if(!Array.isArray(list)) { return }

        const options = list
        .map(industry => {

          industry.name = __(industry.name)
          return industry
        })
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(option => `<option value="${option.slug}">${option.name}</option>`)
        .join('')

        $selectregisterindustry.html(optionselect + options);
        $selectregisterindustry.attr('autocomplete', 'none');
        $selectregisterindustry.attr('aria-autocomplete', 'none');
      })
    })

    const $selectregisterlanguage = $register.find('.xoo-aff-select_list[name="academy_register_language"]')

    fetch(
      '/wp-json/academy/user/languages',
      {
        method: 'GET',
        headers: {
          'X-WP-Nonce': academy_web_site.nonce
        }
      }
    )
    .then(result => {

      const optionselect = `<option value="">${__('Select language')}</option>`

      result.json()
      .then(list => {

        const options = Object.keys(list)
        .map(key => `<option value="${list[key].slug}">${list[key].name}</option>`)
        .join('')

        $selectregisterlanguage.html(optionselect + options);
        $selectregisterlanguage.attr('autocomplete', 'none');
        $selectregisterlanguage.attr('aria-autocomplete', 'none'); 
      }) 
    })

    const $selectregistercountry = $register.find('select[name="academy_register_country"]')

    fetch(
      '/wp-json/academy/user/countries',
      {
        method: 'GET',
        headers: {
          'X-WP-Nonce': academy_web_site.nonce
        }
      }
    )
    .then(result => {

      const optionselect = `<option value="">${__('Select country')}</option>`

      result.json()
      .then(list => {

        const options = Object.keys(list)
        .map(key => `<option value="${key}">${list[key]}</option>`)
        .join('')

        $selectregistercountry.html(optionselect + options);
        $selectregistercountry.attr('autocomplete', 'none');
        $selectregistercountry.attr('aria-autocomplete', 'none');
      })
    })

    const $arearegistera = $register.find('.AcademyConditionsInfoA')
    $arearegistera.replaceWith('<div class="AcademyConditionsInfoA">' +
      __('Conditions-Auhorize') +
    '</div>')

    const $arearegisternewsletter = $register.find('.AcademyRegisterNewsletter')
    $arearegisternewsletter.html($arearegisternewsletter.html().replace(
      'Subscription to newsletter',
      __('Conditions-Email updates')
    ))

    const $arearegistermailpartners = $register.find('.AcademyRegisterMailpartners')
    $arearegistermailpartners.html($arearegistermailpartners.html().replace(
      'Partners mails',
      __('Conditions-Email news')
    ))

    const $arearegisterb = $register.find('.AcademyConditionsInfoB')
    $arearegisterb.replaceWith('<div class="AcademyConditionsInfoB">' +
    __(`Conditions-Personal data`) +
    '</div>')

    $('input[name="xoo_el_reg_pass"], input[name="xoo_el_reg_pass_again"]')
    .each(function() {

      const $field = $(this)
      $field.after(`
        <span 
          class="ShowPassword dashicons dashicons-visibility" 
          aria-hidden="true"
        ></span>
      `)
      $field.siblings('.ShowPassword')
      .on(
        'touchstart mousedown',
        function() {

          $(this).addClass('Showing')          
          $field.attr('type', 'text')
        }
      )
      .on(
        'touchend mouseup mouseleave',
        function() {

          $(this).removeClass('Showing')          
          $field.attr('type', 'password')
        }
      )
    })
  }  

  /*
  if($login.length) { 

    $login = $login.eq(0)

    const $form = $login.find('form.xoo-el-form-login')

    const $usernameinput = $form.find('input[name="xoo-el-username"]')
    const $passwordinput = $form.find('input[name="xoo-el-password"]')
    const $loginbutton = $form.find('button.xoo-el-login-btn')

    // $usernameinput.attr('placeholder', __('Email'))

    setTimeout(() => {

      $usernameinput.val(null)
      $passwordinput.val(null)

    }, 1000)
  }

  */ 

  const $form = $('form.xoo-el-form-login')
  const $logininput = $form.find('input[name="xoo-el-username"]')
  const $loginpassword = $form.find('input[name="xoo-el-password"]')
  $logininput.val('')
  $loginpassword.val('')

  const $xoocontainer = $('.xoo-el-container .xoo-el-close.xoo-el-icon-cancel-circle')
  $xoocontainer
    .on(
    'click',
    function() {

      $register.find('input[type=text], input[type=password], input[type=email]').val('')
      $register.find('input[type=checkbox]').prop( "checked", false )
      $register.find('select').val('').change()
      $logininput.val('')
      $loginpassword.val('')
    }
  )

  const $menulogoutlink = $('#menu-login .xoo-el-logout-menu a, #menu-login-1 .xoo-el-logout-menu a')

  $menulogoutlink
  .on(
    'click',
    function() {

      const $this = $(this)
      const url = $this.attr('href')

      $('body').append('<div id="LogoutConfirm">' + __('Do you really want to logout?') + '</div>')
      $('#LogoutConfirm')
      .dialog({
        modal: true,
        dialogClass: 'LogoutConfirmNoTitle',
        resizable: false,
        buttons: [
          {
            text: __('Logout'),
            class: 'Logout',
            click: function() {

              $(this).dialog('close')

              window.location.href = '/wp-login.php?action=logout'
            }
          },
          {
            text: __('Cancel'),
            class: 'Cancel',
            click: function() {

              $(this).dialog('close')
            }
          }
        ]
      })

      return false
    }
  )

  let $menulinkbutton = $('.xoo-el-login-tgr .menu-link')
  if($menulinkbutton.length) {

    $menulinkbutton
    .each(function() {

      const $this = $(this)
      const buttontext = $this.html()
      const buttontexttranslated = __(buttontext)
      $this.html(buttontexttranslated)
    })
  }

  let $closebutton = $('.xoo-el-close.xoo-el-icon-cancel-circle')
  if($closebutton.length) {

    $closebutton
    .each(function() {

      const $this = $(this)

      $this.on(
        'click',
        function() {

          if(location.search == '?reset_password=true') {

            location.search = ''

            return false
          }
        }
      )
    })
  }   

  let $logoutbutton = $('.xoo-el-logout-menu.menu-item.menu-item-type-custom.menu-item-object-custom .menu-link')
  if($logoutbutton.length) {

    $logoutbutton.html(__('Logout'))
  }

})(jQuery)